"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSignaturePayload = void 0;
const createSignaturePayload = (opts) => {
    const prev = ((opts.prevMsgRef !== undefined) ? `${opts.prevMsgRef.timestamp}${opts.prevMsgRef.sequenceNumber}` : '');
    const newGroupKey = ((opts.newGroupKey !== undefined) ? opts.newGroupKey.serialize() : '');
    return `${opts.messageId.streamId}${opts.messageId.streamPartition}${opts.messageId.timestamp}${opts.messageId.sequenceNumber}`
        + `${opts.messageId.publisherId.toLowerCase()}${opts.messageId.msgChainId}${prev}${opts.serializedContent}${newGroupKey}`;
};
exports.createSignaturePayload = createSignaturePayload;
//# sourceMappingURL=signature.js.map